export default "__VITE_ASSET__BFVw_hr9__"